"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDismissal = void 0;
const react_1 = require("react");
const useLocalStorage_1 = __importDefault(require("react-use/lib/useLocalStorage"));
function useDismissal(key) {
    const [dismissedPersistent, setDismissedPersistent] = (0, useLocalStorage_1.default)(key, false);
    const [dismissedLocal, setDismissedLocal] = (0, react_1.useState)(dismissedPersistent);
    const setDismissed = (0, react_1.useCallback)((dismissed) => {
        if (dismissed && !dismissedPersistent) {
            setDismissedPersistent(true);
        }
        setDismissedLocal(dismissed);
    }, [dismissedPersistent, setDismissedPersistent, setDismissedLocal]);
    return [
        dismissedLocal,
        setDismissed
    ];
}
exports.useDismissal = useDismissal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGlzbWlzc2FsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ob29rcy91c2VEaXNtaXNzYWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlDQUE4QztBQUM5QyxvRkFBNEQ7QUFnQjVELFNBQWdCLFlBQVksQ0FBQyxHQUF3QjtJQUNuRCxNQUFNLENBQUMsbUJBQW1CLEVBQUUsc0JBQXNCLENBQUMsR0FBRyxJQUFBLHlCQUFlLEVBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2xGLE1BQU0sQ0FBQyxjQUFjLEVBQUUsaUJBQWlCLENBQUMsR0FBRyxJQUFBLGdCQUFRLEVBQUMsbUJBQW1CLENBQUMsQ0FBQztJQUMxRSxNQUFNLFlBQVksR0FBRyxJQUFBLG1CQUFXLEVBQUMsQ0FBQyxTQUFrQixFQUFDLEVBQUU7UUFDckQsSUFBRyxTQUFTLElBQUksQ0FBQyxtQkFBbUIsRUFBQztZQUNuQyxzQkFBc0IsQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUM5QjtRQUNELGlCQUFpQixDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQy9CLENBQUMsRUFBRSxDQUFDLG1CQUFtQixFQUFFLHNCQUFzQixFQUFFLGlCQUFpQixDQUFDLENBQUMsQ0FBQztJQUNyRSxPQUFPO1FBQ0wsY0FBYztRQUNsQixZQUFZO0tBQ1QsQ0FBQTtBQUNILENBQUM7QUFiRCxvQ0FhQyJ9